export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Permissions.vue?vue&type=template&id=fd12f442&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Dashboard/Pages/Permissions.vue?vue&type=template&id=fd12f442&scoped=true
// module id = 2267
// module chunks = 31